// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { xPartNumberStyle } from "@plumberssupply/App/SharedStyle/ProductPartNumberStyle";
import {
    getScratchAndDentSellPrice,
    getScratchAndDentStockProduct,
} from "@plumberssupply/App/Store/Selectors/ScratchAndDentSelectors";
import { getScratchAndDentCondition } from "@plumberssupply/App/Store/Selectors/ScratchAndDentSelectors";
import { getScratchAndDentContactInfo } from "@plumberssupply/App/Store/Selectors/ScratchAndDentSelectors";
import { getScratchAndDentLocation } from "@plumberssupply/App/Store/Selectors/ScratchAndDentSelectors";
import { ellipsis, mergeWithCss } from "@plumberssupply/XDL/Utilities";
import React, { FC, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: ScratchAndDentAttributesStyles;
}

type Props = OwnProps & HasProduct;

export interface ScratchAndDentAttributesStyles {
    wrapper?: InjectableCss;
    attributeWrapper?: InjectableCss;
    labelText?: TypographyPresentationProps;
    valueText?: TypographyPresentationProps;
}

export const scratchAndDentStyles: ScratchAndDentAttributesStyles = {
    attributeWrapper: {
        css: css`
            ${ellipsis(1)}
        `,
    },
    labelText: xPartNumberStyle.label,
    valueText: xPartNumberStyle.value,
};

const ProductScratchAndDentAttributes: FC<Props> = ({ product, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(scratchAndDentStyles, extendedStyles));

    if (!getScratchAndDentStockProduct(product.properties)) {
        return null;
    }

    const sdInfo = {
        Location: getScratchAndDentLocation(product.properties),
        "Sell Price": getScratchAndDentSellPrice(product.properties),
        Condition: getScratchAndDentCondition(product.properties),
        Contact: getScratchAndDentContactInfo(product.properties),
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            {Object.entries(sdInfo).map(([label, value]) => {
                return (
                    value && (
                        <StyledWrapper key={label} {...styles.attributeWrapper}>
                            <Typography {...styles.labelText}>{label}</Typography>
                            <Typography {...styles.valueText}>{value}</Typography>
                        </StyledWrapper>
                    )
                );
            })}
        </StyledWrapper>
    );
};

export default withProduct(ProductScratchAndDentAttributes);
